import {
	Calendar,
	CalendarDate,
	CheckCircle,
	ChevronDown,
	Circle,
	ClockStopwatch,
	File06,
	Hash01,
	CheckDone01,
	Edit05,
	Link03,
	Mail01,
	MarkerPin01,
	Phone,
	Plus,
	TextInput,
	Upload01,
	Users01,
} from "@untitledui/icons";
import type { FC, SVGProps } from "react";
import type { PaletteFieldType } from "../types";

/**
 * English fallbacks when the remote translation bundle omits a palette key or returns an empty string.
 * Keeps new fields (e.g. textarea) usable in the builder before copy is added server-side.
 */
export const PALETTE_FIELD_DEFAULT_LABELS: Record<PaletteFieldType, string> = {
	text: "Text Input",
	textarea: "Text Area",
	number: "Number",
	email: "Email",
	phone: "Phone",
	date: "Date",
	time: "Time",
	dateTime: "Date & Time",
	select: "Dropdown",
	radio: "Radio Buttons",
	checkbox: "Checkbox",
	file: "File Upload",
	url: "URL",
	multiSelect: "Multi-select",
	users: "Users",
	signature: "Signature",
	address: "Address",
};

export interface PaletteItemMeta {
	type: PaletteFieldType;
	labelKey: string;
	Icon: FC<SVGProps<SVGSVGElement>>;
}

/** i18n keys under `admin.shared.formEditor.palette.*` */
export const PALETTE_ITEMS: PaletteItemMeta[] = [
	{ type: "text", labelKey: "text", Icon: TextInput },
	{ type: "textarea", labelKey: "textArea", Icon: File06 },
	{ type: "number", labelKey: "number", Icon: Hash01 },
	{ type: "email", labelKey: "email", Icon: Mail01 },
	{ type: "phone", labelKey: "phone", Icon: Phone },
	{ type: "date", labelKey: "date", Icon: Calendar },
	{ type: "time", labelKey: "time", Icon: ClockStopwatch },
	{ type: "dateTime", labelKey: "dateTime", Icon: CalendarDate },
	{ type: "select", labelKey: "select", Icon: ChevronDown },
	{ type: "radio", labelKey: "radio", Icon: Circle },
	{ type: "checkbox", labelKey: "checkbox", Icon: CheckCircle },
	{ type: "file", labelKey: "file", Icon: Upload01 },
	{ type: "url", labelKey: "url", Icon: Link03 },
	{ type: "multiSelect", labelKey: "multiSelect", Icon: CheckDone01 },
	{ type: "users", labelKey: "users", Icon: Users01 },
	{ type: "signature", labelKey: "signature", Icon: Edit05 },
	{ type: "address", labelKey: "address", Icon: MarkerPin01 },
];

/**
 * Segment for `admin.shared.formEditor.palette.types.*` from a stored field type.
 * Differs from {@link PaletteFieldType} when the palette id differs from the translation key (rare).
 */
export function paletteFieldTypeToI18nKey(fieldType: PaletteFieldType): string {
	const item = PALETTE_ITEMS.find((p) => p.type === fieldType);
	return item?.labelKey ?? fieldType;
}

export { Plus };
